import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

function QuestionLabel({
  itemIndex,
  qLabel,
  refId,
  endOfSurvey,
  goesToEndGroup,
}) {
  if (endOfSurvey) {
    return (
      <span>
        {itemIndex > 0 && <span>,&nbsp;</span>}
        <FormattedMessage {...messages.endOfSurvey} key={refId} />
      </span>
    );
  }
  return (
    <span key={refId}>
      {itemIndex > 0 && <span>,&nbsp;</span>}
      <span>{goesToEndGroup ? `${qLabel} end` : qLabel}</span>
    </span>
  );
}

QuestionLabel.propTypes = {
  itemIndex: PropTypes.number,
  qIndex: PropTypes.number,
  refId: PropTypes.string,
  endOfSurvey: PropTypes.bool,
};

export default QuestionLabel;
